import React from 'react';
import './Page.css';

function PrivacyPolicy() {
  return (
    <div className="page privacy-policy-page">
      <div className="page-content">
        <div className="section-heading">
          <div className="accent-line" aria-hidden="true"></div>
          <h1>Privacy Policy</h1>
        </div>
        <div className="section-body">
          <p>
            This page intends to inform our website visitors about the personal information that we may collect upon their visit and the manner in which the personal information may be used. If you choose to visit our website, then you agree to the collection and use of information as per our privacy policy. Please note the following:
          </p>
          <ul className="privacy-points">
            <li className="privacy-point">
              <p>We will not share or use the information with anyone except as described in the privacy policy.</p>
            </li>
            <li className="privacy-point">
              <p>We do not use cookies on this website.</p>
            </li>
            <li className="privacy-point">
              <p>We may collect information which you enter on the website and may use it for timely follow-ups.</p>
            </li>
            <li className="privacy-point">
              <p>We do not transfer any of your details to outside parties. This excludes website hosting and maintenance partners who assist us in operating the website.</p>
            </li>
            <li className="privacy-point">
              <p>We may update this privacy policy by posting a new version on this website. You should check this page occasionally to ensure you are familiar with any changes.</p>
            </li>
          </ul>
          <p>
            If you have any questions on our privacy policy, please email at: <a href="mailto:info@yk2partners.com" aria-label="info@yk2partners.com Email YK2 Partners with privacy policy questions">info@yk2partners.com</a>
          </p>
          <p className="last-updated">
            Last updated: February 2026
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
